import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import BackInStock from './BackInStockList';

export default {
    icon: CircleNotificationsIcon,
    list: BackInStock,
};
